import { Component } from '@angular/core';
import { CampaignDetailsFormComponent } from '../../../../../components/forms/campaignforms/campaign-details-form/campaign-details-form.component';
import { CampaignDetailsPreviewComponent } from '../../../../../components/forms/campaignpreviews/campaign-details-preview/campaign-details-preview.component';

/** Wizard step 1: name, description and goals, with a live summary. */
@Component({
  selector: 'app-campaign-details',
  standalone: true,
  imports: [CampaignDetailsFormComponent, CampaignDetailsPreviewComponent],
  templateUrl: './campaign-details.component.html',
  styleUrl: '../wizard-step.css',
})
export class CampaignDetailsComponent {}
